import primaryComponents from "../../primaryComponents";
import Pagination from "../Pagination/Pagination";
import { useBillsWidget } from "./useBillsWidget";
import secondaryComponents from "..";
import Orderflows from "../StoreCheckout/Orderflows";
import OrderCancel from "./orderCancel";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import { RoutedModal } from "../../common";

const BillsWidget = () => {
  const {
    bills,
    instance,
    isFetchingBills,
    billPageDetails,
    selectedOrder,
    isOrderCancel,
    billWasUpdated,
    search,
    setIsOrderCancel,
    setSelectedOrder,
    gotoPage,
    filterBySearch,
    filterByKey,
    setBillWasUpdated,
  } = useBillsWidget({});
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <section className={`${globalStyles.cardWithBorder} overflow-hidden p-0`}>
        <div className={globalStyles.tableHeader}>
          <primaryComponents.SearchField
            classNames={globalStyles.searchField}
            placeholder={
              "Search order by order ID , customer name or table name"
            }
            trigger={(value) => filterBySearch(value)}
            value={search.get("query") || ""}
            triggerOnInput={true}
            showsearchBtn={true}
          />

          <div className="ml-auto" style={{ maxWidth: "200px", width: "100%" }}>
            <primaryComponents.SelectField
              value="Unpaid"
              options={[
                { label: "All", value: null },
                { label: "Paid", value: "COMPLETED" },
                { label: "Unpaid", value: "bill" },
              ]}
              onChange={(value) => {
                filterByKey("payment_method", value);
              }}
              nameKey="label"
              idKey="value"
              isSearchable={false}
              floatError={false}
            />
          </div>
        </div>

        <secondaryComponents.LoaderHelper
          isLoading={isFetchingBills}
          classNames="my-5"
        >
          <secondaryComponents.TableHelper
            getTableBodyProps={getTableBodyProps}
            getTableProps={getTableProps}
            headerGroups={headerGroups}
            rows={rows}
            prepareRow={prepareRow}
            handleScroll={true}
            hasAction={true}
          >
            <h4 className="my-5 text-center">No Data Available</h4>
          </secondaryComponents.TableHelper>

          {bills?.length > 0 && billPageDetails?.next_page ? (
            <div className="mt-auto">
              <Pagination
                totalPageNumber={billPageDetails?.last_page}
                handlePageClick={(value) => gotoPage(value.selected + 1)}
                currentPage={billPageDetails?.current_page}
              />
            </div>
          ) : null}
        </secondaryComponents.LoaderHelper>
      </section>

      <secondaryComponents.Modal
        isActive={selectedOrder !== null}
        closeModal={() => setSelectedOrder(null)}
        width={1300}
        padding={0}
        style={{ maxHeight: "100%", height: "100vh", borderRadius: "0" }}
      >
        <Orderflows
          closeModal={() => setSelectedOrder(null)}
          orderId={selectedOrder}
          defaultLanding={"tnxReceipt"}
          viaSaleRecord={true}
        />
      </secondaryComponents.Modal>

      {/* modal */}
      <secondaryComponents.Modal
        isActive={isOrderCancel !== null}
        closeModal={() => setIsOrderCancel(null)}
        width={500}
      >
        <OrderCancel
          closeWidget={() => setIsOrderCancel(null)}
          orderDetails={isOrderCancel}
        />
      </secondaryComponents.Modal>

      <RoutedModal
        isActive={billWasUpdated !== null}
        closeModal={() => setBillWasUpdated(null)}
        width={1300}
        headerTitle="Bill Update"
      >
        <secondaryComponents.BillUpdate
          orderId={billWasUpdated}
          resetView={() => setBillWasUpdated(null)}
          setBillWasUpdated={setBillWasUpdated}
          isOrderFlow={false}
        />
      </RoutedModal>
    </>
  );
};

export default BillsWidget;
